import StatusCard from './StatusCard';

const StatusCardList = ({ dashboardData }: any) => {
  const data = dashboardData || {};
  const businessType = sessionStorage.getItem('businessType');

  let formattedData = [
    {
      title: 'Total Complaints',
      count: data?.complaints?.total?.toLocaleString() || '0',
      percent: data?.complaints?.percentage ? `${data.complaints.percentage.toFixed(1)}%` : '',
      status:
        data?.complaints?.percentage !== undefined && data.complaints.percentage >= 0
          ? 'positive'
          : 'negative'
    },
    {
      title: 'Total Enquiries',
      count: data?.enquiry?.total?.toLocaleString() || '0',
      percent: data?.enquiry?.percentage ? `${data.enquiry.percentage.toFixed(1)}%` : '',
      status:
        data?.enquiry?.percentage !== undefined && data.enquiry.percentage >= 0
          ? 'positive'
          : 'negative'
    }
  ];

  if (businessType === 'Hospitality') {
    formattedData.push(
      {
        title: 'Total Check-in',
        count: data?.checkIn?.total.toLocaleString() || '0',
        percent: data?.checkIn?.percentage ? `${data.checkIn.percentage.toFixed(1)}%` : '',
        status: data?.checkIn?.percentage !== undefined && data.checkIn.percentage >= 0
          ? 'positive'
          : 'negative'
      },
      {
        title: 'Total Booking',
        count: data?.bookings?.total?.toLocaleString() || '0',
        percent: data?.bookings?.percentage ? `${data.bookings.percentage.toFixed(1)}%` : '',
        status:
          data?.bookings?.percentage !== undefined && data.bookings.percentage >= 0
            ? 'positive'
            : 'negative'
      }
    );
  } else {
    formattedData.push(
      {
        title: 'Total Feedback',
        count: data?.feedbacks?.total.toLocaleString() || '0',
        percent: data?.feedbacks?.percentage ? `${data.feedbacks.percentage.toFixed(1)}%` : '',
        status: data?.feedbacks?.percentage !== undefined && data.feedbacks.percentage >= 0
          ? 'positive'
          : 'negative'
      },
      {
        title: 'Total Callback',
        count: data?.callBackRequest?.total?.toLocaleString() || '0',
        percent: data?.callBackRequest?.percentage
          ? `${data.callBackRequest.percentage.toFixed(1)}%`
          : '',
        status:
          data?.callBackRequest?.percentage !== undefined && data.callBackRequest.percentage >= 0
            ? 'positive'
            : 'negative'
      }
    );
  }

  return (
    <div className="grid gap-5 grid-cols-1   md:grid-cols-3 lg:grid-cols-4">
      {formattedData.map((info: any, index: number) => (
        <StatusCard info={info} index={index} key={index} />
      ))}
    </div>
  );
};

export default StatusCardList;
